import Vue from "vue";
import Vuex from "vuex";
import { TIME, DLR_INFOS } from "./mutations-types";
import notification from "./modules/notification";
import priority from "./modules/priority";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    operators: [
      { text: "$vuetify.sms.model.operator.mtn", value: "mtn" },
      { text: "$vuetify.sms.model.operator.ocm", value: "ocm" },
      { text: "$vuetify.sms.model.operator.ctl", value: "ctl" },
      { text: "$vuetify.sms.model.operator.nex", value: "nex" },
      { text: "$vuetify.sms.model.operator.other", value: "other" }
    ],
    trackings: [
      { text: "$vuetify.sms.model.dlr.PENDING", value: "PENDING" },
      { text: "$vuetify.sms.model.dlr.DELIVERED", value: "DELIVERED" },
      { text: "$vuetify.sms.model.dlr.NOT_DELIVERED", value: "NOT_DELIVERED" },
      {
        text: "$vuetify.sms.model.dlr.ABSENT_SUBSCRIBER",
        value: "ABSENT_SUBSCRIBER"
      },
      {
        text: "$vuetify.sms.model.dlr.COMMAND_REJECTED",
        value: "COMMAND_REJECTED"
      },
      { text: "$vuetify.sms.model.dlr.ERROR_UNKNOWN", value: "ERROR_UNKNOWN" },
      {
        text: "$vuetify.sms.model.dlr.MESSAGE_EXPIRED",
        value: "MESSAGE_EXPIRED"
      },
      {
        text: "$vuetify.sms.model.dlr.MESSAGE_SYNTAX_ERROR",
        value: "MESSAGE_SYNTAX_ERROR"
      },
      {
        text: "$vuetify.sms.model.dlr.MOBILE_STATION_APPLICATION_ERROR",
        value: "MOBILE_STATION_APPLICATION_ERROR"
      },
      {
        text: "$vuetify.sms.model.dlr.MOBILE_STATION_ERROR",
        value: "MOBILE_STATION_ERROR"
      },
      { text: "$vuetify.sms.model.dlr.NETWORK_ERROR", value: "NETWORK_ERROR" },
      {
        text: "$vuetify.sms.model.dlr.NETWORK_FAILURE",
        value: "NETWORK_FAILURE"
      },
      { text: "$vuetify.sms.model.dlr.SYNTAX_ERROR", value: "SYNTAX_ERROR" },
      {
        text: "$vuetify.sms.model.dlr.TP_DCS_REJECTED",
        value: "TP_DCS_REJECTED"
      },
      {
        text: "$vuetify.sms.model.dlr.TP_DU_REJECTED",
        value: "TP_DU_REJECTED"
      },
      {
        text: "$vuetify.sms.model.dlr.TP_PID_REJECTED",
        value: "TP_PID_REJECTED"
      },
      {
        text: "$vuetify.sms.model.dlr.UNKNOWN_SUBSCRIBER",
        value: "UNKNOWN_SUBSCRIBER"
      },
      { text: "$vuetify.sms.model.dlr.MESSAGE_READ", value: "MESSAGE_READ" },
      {
        text: "$vuetify.sms.model.dlr.MESSAGE_DELETED",
        value: "MESSAGE_DELETED"
      },
      {
        text: "$vuetify.sms.model.dlr.MESSAGE_INTERMEDIATE_STATE",
        value: "MESSAGE_INTERMEDIATE_STATE"
      },
      {
        text: "$vuetify.sms.model.dlr.MESSAGE_FORWARDED",
        value: "MESSAGE_FORWARDED"
      }
    ],
    serverTypes: [
      { text: "$vuetify.system.servers.model.type.mmg", value: "MMG" },
      { text: "$vuetify.system.servers.model.type.ozeki", value: "OZEKI" }
    ],
    pushFileDetailStatuses: [
      { text: "$vuetify.pushes.advanced.details.model.status.treated", value: "1" },
      { text: "$vuetify.pushes.advanced.details.model.status.untreated", value: "0" }
    ],
    smsSources: [
      { text: "$vuetify.sms.model.source.api_public", value: "api_public" },
      { text: "$vuetify.sms.model.source.push_web", value: "push_web" },
      { text: "$vuetify.others", value: "other" }
    ],
    time: null,
    dlrInfos: []
  },
  getters: {
    operators: state => {
      return state.operators;
    },
    trackings: state => {
      return state.trackings;
    },
    serverTypes: state => {
      return state.serverTypes;
    },
    pushFileDetailStatuses: state => {
      return state.pushFileDetailStatuses;
    },
    smsSources: state => {
      return state.smsSources
    },
    time: state => {
      return state.time;
    },
    dlrInfos: state => {
      return state.dlrInfos;
    }
  },
  mutations: {
    [TIME](state, time) {
      state.time = time;
    },
    [DLR_INFOS](state, dlrInfos) {
      state.dlrInfos = dlrInfos;
    }
  },
  actions: {
    async request(store, params) {
      return Vue.axios.request(params);
    },
    async setTime(store) {
      try {
        const response = store.dispatch("request", { url: "systems/time" });
        store.commit(TIME, response.data.time);
      } catch (error) {
        store.commit(TIME, new Date().getTime());
      }
    },
    async setDlrInfos(store) {
      const response = await store.dispatch("request", { url: "systems/dlr-infos" });
      store.commit(DLR_INFOS, response.data.datas);
      return response;
    }
  },
  modules: {
    notification: notification,
    priority: priority
  }
});
